import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    alignItems: "center",
    height: "100%",
    width: "100%",
    padding: designTokens.spacing[5],
    boxSizing: "border-box",
    "@media (max-width: 480px)": {
      padding: designTokens.spacing[4],
    },
  },

  content: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },

  warningCircle: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: designTokens.semantic.warningLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  title: {
    width: "100%",
    maxWidth: "90%",
    "@media (min-width: 640px)": {
      width: "50%",
      maxWidth: "80%",
    },
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize["2xl"],
      paddingTop: designTokens.spacing[4],
    },
    color: designTokens.neutral[800],
    fontWeight: designTokens.fontWeight.bold,
    fontSize: designTokens.fontSize["3xl"],
    textAlign: "center",
    paddingTop: designTokens.spacing[8],
  },

  messageContent: {
    fontSize: designTokens.fontSize.base,
    color: designTokens.neutral[600],
    maxWidth: "640px",
    lineHeight: String(designTokens.lineHeight.relaxed),
    whiteSpace: "pre-line",
    textAlign: "center",
    paddingTop: designTokens.spacing[4],
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.sm,
    },
  },
});
